import React from 'react';
import { Heading, Section } from '../../styles/styled-components';

const About = () => {
    return (
        <Section>
            <Heading>About</Heading>
            <p>> B Severino is a front end web developer and digital artist working out of Connecticut, USA. They have been training and working as a visual artist since 2010, and are currently attending Lambda School's web track to further their skills.</p>
        </Section>
    );
};

export default About;